export const SET_CURRENT_THREAD_LIST = 'SET_CURRENT_THREAD_LIST';